import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FileEarmarkCheck } from "react-bootstrap-icons";

// Canonical status colors from PreauthorizationVolume.js
const statusConfig = {
  ready: {
    color: "#00965e",
    bg: "#e7faf1",
    border: "#bcf0da",
    label: "Ready for Submission",
  }, // approved / ready green
  error: { color: "#f5803e", label: "Validation Errors" }, // error orange
};

const BEFORE_METRICS = [
  {
    title: "Number of Claims",
    totalDisplay: "1,416 Claims",
    readyVal: "1,132 Claims",
    readyPct: 79.94,
    errorVal: "284 Claims",
    errorPct: 20.06,
  },
  {
    title: "Gross Amount",
    totalDisplay: "740.2k SAR",
    readyVal: "580.0k SAR",
    readyPct: 78.36,
    errorVal: "160.0k SAR",
    errorPct: 21.64,
  },
  {
    title: "Discount",
    totalDisplay: "48.5k SAR",
    readyVal: "38.2k SAR",
    readyPct: 78.76,
    errorVal: "10.3k SAR",
    errorPct: 21.24,
  },
  {
    title: "Patient Share",
    totalDisplay: "32.1k SAR",
    readyVal: "25.1k SAR",
    readyPct: 78.19,
    errorVal: "7.0k SAR",
    errorPct: 21.81,
  },
  {
    title: "Net Amount",
    totalDisplay: "675.3k SAR",
    readyVal: "530.1k SAR",
    readyPct: 78.5,
    errorVal: "145.2k SAR",
    errorPct: 21.5,
  },
  {
    title: "VAT Amount",
    totalDisplay: "82.5k SAR",
    readyVal: "65.2k SAR",
    readyPct: 79.03,
    errorVal: "17.3k SAR",
    errorPct: 20.97,
  },
];

const StatsAllClaimBeforeSubmission = () => {
  return (
    <Col xs={12} className="mt-3">
      <Card className="h-100 shadow-sm border">
        {/* Header with Title & Legend */}
        <Card.Header className="d-flex flex-column flex-sm-row align-items-sm-center p-3 justify-content-between pb-3 border-bottom gap-3">
          <div className="d-flex align-items-center gap-2">
            <div
              className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "8px",
                backgroundColor: statusConfig.ready.bg,
                color: statusConfig.ready.color,
                border: `1px solid ${statusConfig.ready.border}`,
              }}
            >
              <FileEarmarkCheck size={15} />
            </div>
            <div>
              <h6
                className="mb-0 fw-bold"
                style={{ fontSize: "14px" }}
              >
                All Claims Before Submission
              </h6>
              <small className="text-muted" style={{ fontSize: "11px" }}>
                Pre-submission queue status and validation check breakdown
              </small>
            </div>
          </div>

          {/* Legend */}
          <div
            className="d-flex align-items-center gap-3 fw-semi-bold"
            style={{ fontSize: "12px" }}
          >
            <div
              className="d-flex align-items-center gap-1"
              style={{ color: statusConfig.ready.color }}
            >
              <span
                className="rounded-circle d-inline-block"
                style={{
                  width: "10px",
                  height: "10px",
                  backgroundColor: statusConfig.ready.color,
                }}
              ></span>
              <span>{statusConfig.ready.label}</span>
            </div>
            <div
              className="d-flex align-items-center gap-1"
              style={{ color: statusConfig.error.color }}
            >
              <span
                className="rounded-circle d-inline-block"
                style={{
                  width: "10px",
                  height: "10px",
                  backgroundColor: statusConfig.error.color,
                }}
              ></span>
              <span>{statusConfig.error.label}</span>
            </div>
          </div>
        </Card.Header>

        {/* 6 Grid Cards */}
        <Card.Body className="p-3">
          <Row className="g-3">
            {BEFORE_METRICS.map((m) => (
              <Col xs={12} sm={6} md={4} lg={2} key={m.title}>
                <div
                  className="p-3 rounded border h-100 d-flex flex-column justify-content-between"
                  style={{ transition: "all 0.2s ease" }}
                >
                  <div>
                    <div
                      className="fw-semi-bold text-muted text-uppercase"
                      style={{ fontSize: "11px" }}
                    >
                      {m.title}
                    </div>
                    <div
                      className="fw-bold font-monospace mt-1"
                      style={{ fontSize: "18px" }}
                    >
                      {m.totalDisplay}
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="mt-3 pt-2 border-top">
                    <div
                      className="w-100 bg-200 rounded-pill overflow-hidden d-flex mb-2"
                      style={{ height: "6px" }}
                    >
                      <div
                        style={{
                          width: `${m.readyPct}%`,
                          backgroundColor: statusConfig.ready.color,
                        }}
                      ></div>
                      <div
                        style={{
                          width: `${m.errorPct}%`,
                          backgroundColor: statusConfig.error.color,
                        }}
                      ></div>
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-between fw-semi-bold mb-1"
                      style={{ fontSize: "10px" }}
                    >
                      <span
                        className="d-flex align-items-center gap-1"
                        style={{ color: statusConfig.ready.color }}
                      >
                        <span>{m.readyVal}</span>
                        <span className="text-muted font-monospace">
                          ({m.readyPct.toFixed(1)}%)
                        </span>
                      </span>
                    </div>

                    <div
                      className="d-flex align-items-center justify-content-between fw-semi-bold"
                      style={{ fontSize: "10px" }}
                    >
                      <span
                        className="d-flex align-items-center gap-1"
                        style={{ color: statusConfig.error.color }}
                      >
                        <span>{m.errorVal}</span>
                        <span className="text-muted font-monospace">
                          ({m.errorPct.toFixed(1)}%)
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default StatsAllClaimBeforeSubmission;
